import { useMemo } from 'react';

import {
  buildUnderConstructionSet,
  useModuleTagging,
} from '@suntex.fim/framework';

export function useUnderConstruction(): {
  isUnderConstruction: (slug: string) => boolean;
  isLoading: boolean;
} {
  const { moduleTagging, isLoading } = useModuleTagging();

  const underConstructionSet = useMemo(
    () =>
      moduleTagging ? buildUnderConstructionSet(moduleTagging) : undefined,
    [moduleTagging],
  );

  const isUnderConstruction = useMemo(
    () => (slug: string) => underConstructionSet?.has(slug) ?? false,
    [underConstructionSet],
  );

  return { isUnderConstruction, isLoading };
}
